/* eslint-disable max-len */
import React from 'react';

const PlusActiveIcon = props => (
  <svg width={25} height={25} viewBox="0 0 25 25" {...props}>
    <path
      fillRule="evenodd"
      d="M13.207 12.5l3.394 3.394a.2.2 0 0 1 0 .283l-.424.424a.2.2 0 0 1-.283 0L12.5 13.207l-3.394 3.394a.2.2 0 0 1-.283 0l-.424-.424a.2.2 0 0 1 0-.283l3.394-3.394-3.394-3.394a.2.2 0 0 1 0-.283l.424-.424a.2.2 0 0 1 .283 0l3.394 3.394 3.394-3.394a.2.2 0 0 1 .283 0l.424.424a.2.2 0 0 1 0 .283L13.207 12.5zM12.5 25C5.596 25 0 19.404 0 12.5S5.596 0 12.5 0 25 5.596 25 12.5 19.404 25 12.5 25zm0-1C18.851 24 24 18.851 24 12.5S18.851 1 12.5 1 1 6.149 1 12.5 6.149 24 12.5 24z"
    />
  </svg>
);

export default PlusActiveIcon;
